var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.routers.length > 0
    ? _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c(
            "div",
            { staticClass: "nav-wrap" },
            [_c("nav-bar", { attrs: { routers: _vm.routers } })],
            1
          ),
          _c("router-view", { staticClass: "main" }),
        ],
        1
      )
    : _c("div", { staticClass: "wrapper" }, [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-permission" }, [
      _c("p", [_vm._v("您没有权限访问此页面")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }